import {useRef, useState, useCallback, useEffect} from "react";
import {useTranslation} from "react-i18next";
import cookies from "../../utils/cookies";
import Button from "../Button";
import useNotice from "../../hooks/useNotice";

export default function ShareNav() {
  const agentInfo = cookies.getAgentInfo();
  const ref = useRef(null);
  const whats = useRef(null);
  const facebook = useRef(null);
  const twitter = useRef(null);
  const pinterest = useRef(null);
  const linkedin = useRef(null);
  const [visible, setVisible] = useState(false);
  const [url, setUrl] = useState('');
  const { t } = useTranslation();
  const notice = useNotice();
  
  const selectUrl = (name) => {
    let shareWebsite = {
      fbUrl: 'https://www.facebook.com/sharer.php?title=填上你的标题&u=http://example.com',
      twitterUrl: 'https://twitter.com/share?text=填上你的标题&url=http://example.com',
      pinterest: 'https://www.pinterest.com/pin/create/botton?url=',
      linkedin: 'https://www.linkedin.com/shareArticle?'
    };
    let _href = encodeURIComponent(location.href);
    if (name === 'fbUrl') {
      window.open(`https://www.facebook.com/sharer.php?title=${document.title}&u=${_href}`);
    }
    
    if (name === 'whatsappUrl') {
      let _url = 'https://api.whatsapp.com/send?text=' + document.title;
      _url += ' %0A ' + _href
      window.open(_url);
    }
    
    if (name === 'twitterUrl') {
      window.open(`https://twitter.com/share?text=${document.title}&url=${_href}`);
    }
    
    if (name === 'pinterest') {
      window.open(`https://www.pinterest.com/pin/create/botton?url=${_href}`);
    }
    
    if (name === 'linkedin') {
      window.open(`https://www.linkedin.com/shareArticle?mini=true&title${document.title}&url=${_href}`);
    }
    
    return;
    window.open(agentInfo[name], name, 'height=650,innerHeight=650,width=800,innerWidth=800');
    
    return;
    setUrl(agentInfo[name]);
    if (url === agentInfo[name] && visible) {
      setVisible(false);
    } else {
      setVisible(true);
    }
  };
  
  const copy = () => {
    if (ref.current) {
      if (document.execCommand('copy')) {
        ref.current.select();
        document.execCommand('copy');
        notice.success(t('复制成功'));
      } else {
        notice.error(t('复制失败'));
      }
    }
  };
  
  const open = () => {
    window.open(url);
  };
  
  return (
    <div className="flex items-center">
      {
        agentInfo.whatsappUrl || agentInfo.fbUrl || agentInfo.twitterUrl ?
          <p className="text-[16px]">{t('分享')}：</p> : null
      }
      
      <div>
        <div className="relative">
          {
            agentInfo.whatsappUrl &&
            <i ref={whats}
               onClick={() => selectUrl('whatsappUrl')}
               className="iconfont cursor-pointer text-[20px] mx-[10px] icon-whats"/>
          }
          {
            agentInfo.fbUrl &&
            <i ref={facebook}
               onClick={() => selectUrl('fbUrl')}
               className="iconfont cursor-pointer text-[20px] mx-[10px] icon-facebook"/>
          }
          {
            agentInfo.twitterUrl &&
            <i ref={twitter}
               onClick={() => selectUrl('twitterUrl')}
               className="iconfont cursor-pointer text-[20px] mx-[10px] icon-twitter"/>
          }
          
          {
            agentInfo.pinterest &&
            <i ref={pinterest}
               onClick={() => selectUrl('pinterest')}
               className="iconfont cursor-pointer text-[20px] mx-[10px] icon-pinterestpinterest30"/>
          }
          
          {
            agentInfo.linkedin &&
            <i ref={linkedin}
               onClick={() => selectUrl('linkedin')}
               className="iconfont cursor-pointer text-[20px] mx-[10px] icon-linkedin1"/>
          }
          
          {
            visible &&
            <div className="absolute top-[40px] py-[15px] px-[24px] w-[400px] z-10 bg-white"
                 style={{ boxShadow: '0 1px 10px rgba(0,0,0,.2)' }}>
              <div className="flex justify-between mb-[12px]">
                <p>{t('复制')}</p>
                <i onClickCapture={() => setVisible(false)}
                   className="iconfont icon-delete text-[#999] cursor-pointer"/>
              </div>
              <div className="flex mb-[10px]">
                <input type="text"
                       ref={ref}
                       value={url}
                       disabled={true}
                       className="border inline-block rounded-[5px] border-[#d4d4d4] px-[15px] py-[8px] flex-1"/>
                <Button onClick={copy}
                        className="ml-[15px] p-0 bg-[#eee] rounded-[5px] px-[15px]">{t('复制')}</Button>
                
                <Button onClick={open}
                        className="ml-[15px] p-0 bg-[#eece7a] rounded-[5px] px-[15px]">{t('分享')}</Button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
